import { Radio } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function RadioCard({ asRoot, value, checked, onClick, onChange, children, className, ...props }) {
  const RootComponent = asRoot || S.Card;

  return (
    <RootComponent checked={checked} onClick={onClick} className={className}>
      <Radio value={value} checked={checked} onChange={onChange} {...props} />
      {children}
    </RootComponent>
  );
}

RadioCard.propTypes = {
  asRoot: PropTypes.elementType,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export { RadioCard };
